import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-slate-50 px-4">
      <Helmet>
        <title>Siden blev ikke fundet - 404 - Trapezdk</title>
        <meta name="description" content="Siden du leder efter, findes desværre ikke. Gå tilbage til forsiden af Trapezdk." />
      </Helmet>

      <div className="max-w-md w-full text-center space-y-6 bg-white p-8 sm:p-10 rounded-2xl shadow-md border border-slate-100">
        <div className="w-20 h-20 rounded-full bg-rose-50 border border-rose-100 flex items-center justify-center text-rose-500 mx-auto">
          <i className="fa-solid fa-triangle-exclamation text-3xl"></i>
        </div>
        
        <div className="space-y-2">
          <h1 className="text-4xl font-extrabold text-brand-blue tracking-tight">404</h1>
          <h2 className="text-xl font-bold text-slate-900">Siden blev ikke fundet</h2>
          <p className="text-slate-500 text-sm leading-relaxed">
            Beklager, men den side du leder efter findes ikke eller er blevet flyttet.
          </p>
        </div>

        <div className="pt-2">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 px-6 py-3 bg-brand-blue hover:bg-brand-blue-light text-white font-semibold rounded-xl transition-all shadow-sm hover:shadow cursor-pointer"
          >
            <i className="fa-solid fa-house text-sm"></i>
            <span>Gå til forsiden</span>
          </Link>
        </div>
      </div>
    </div>
  )
}
